import { images } from '@/asset';
import { apiCaller } from '@/redux/query';

interface IProps {
  title: string;
  description: string;
  style?: React.CSSProperties;
}

const appId = process.env.REACT_APP_BE_APP_ID;

const UpgradeText = ({ title, description, style }: IProps) => {
  const { data: dataSetting } = apiCaller.useGeneralSettingsQuery();
  return (
    <div className="d-flex mb-4" style={style}>
      <img className="mr-4" src={images.crown} alt="vip" />
      <p>
        <span
          onClick={() => {
            window.open(`https://www.wix.com/apps/upgrade/${appId}?appInstanceId=${dataSetting?.data?.instanceId}`);
          }}
          style={{ cursor: 'pointer', textDecoration: 'underline', color: 'var(--p-color-text-emphasis)' }}
        >
          {title || 'Upgrade to Premium plan'}
        </span>
        <span style={{ marginLeft: 4, color: '#9b6d00' }}>{description || 'to unlock feature.'}</span>
      </p>
    </div>
  );
};

export default UpgradeText;
